import React, { useState, useEffect } from "react";
import DashBoardSidebar from "../../layouts/dashBoard-Sidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import { toast } from "react-toastify";
import {
  getAllCert,
  getAllCertRetake,
  getAllInProgressPhoneCourses,
  getFollowup,
  getFollowupRetake,
  getGladeFollowup,
  getGladePendingCertificates,
  getIncompleteCertificates,
} from "../../api/server";
import PaginatedItems from "./pagination";
import { ThreeDots } from "react-loader-spinner";
import { Link } from "react-router-dom";
import moment from "moment";
import gladeBadge from "../../assets/images/glade-badge.png";
import "./certificates.css";

const Certificates = () => {
  const [getloading, setGetLoading] = useState(true);

  const [response, setResponse] = useState([]);
  const [pageCache, setPageCache] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [total, setTotal] = useState();
  const [gladeResponse, setGladeResponse] = useState([]);
  const [gladePageCache, setGladePageCache] = useState({});
  const [gladeTotal, setGladeTotal] = useState(0);
  const [gladeLoading, setGladeLoading] = useState(true);
  const [getloadingFollow, setGetLoadingFollow] = useState(true);
  const [responseFollow, setResponseFollow] = useState([]);
  const [pageCacheFollow, setPageCacheFollow] = useState({});
  const [pageNoFollow, setPageNoFollow] = useState(1);
  const [totalFollow, setTotalFollow] = useState();
  const [gladeFollowupResponse, setGladeFollowupResponse] = useState([]);
  const [gladeFollowupPageCache, setGladeFollowupPageCache] = useState({});
  const [gladeFollowupTotal, setGladeFollowupTotal] = useState(0);
  const [gladeFollowupLoading, setGladeFollowupLoading] = useState(true);

  const [getloadingRetake, setGetLoadingRetake] = useState(true);
  const [responseRetake, setResponseRetake] = useState([]);
  const [pageCacheRetake, setPageCacheRetake] = useState({});
  const [pageNoRetake, setPageNoRetake] = useState(1);
  const [totalRetake, setTotalRetake] = useState();
  const [getloadingFollowRetake, setGetLoadingFollowRetake] = useState(true);
  const [responseFollowRetake, setResponseFollowRetake] = useState([]);
  const [pageCacheFollowRetake, setPageCacheFollowRetake] = useState({});
  const [pageNoFollowRetake, setPageNoFollowRetake] = useState(1);
  const [totalFollowRetake, setTotalFollowRetake] = useState();

  const [pageNoIncompleteCerts, setPageNoIncompleteCerts] = useState(1);
  const [pageCacheIncompleteCerts, setPageCacheIncompleteCerts] = useState({});
  const [incompleteCertsData, setIncompleteCertsData] = useState([]);
  const [totalIncompleteCerts, setTotalIncompleteCerts] = useState(0);
  const [loadingIncompleteCerts, setLoadingIncompleteCerts] = useState(false);

  const [phoneCourseResponse, setPhoneCourseResponse] = useState([]);
  const [phoneCourseTotal, setPhoneCourseTotal] = useState(0);
  const [phoneCourseLoading, setPhoneCourseLoading] = useState(false);
  const [phoneCoursePageCache, setPhoneCoursePageCache] = useState({});
  const [phonePageNo, setPhonePageNo] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      if (pageCacheFollow[pageNoFollow]) {
        // Data already in cache, no need for API call
        const { cachedResponse, cachedTotal } = pageCacheFollow[pageNoFollow];
        setResponseFollow(cachedResponse);
        setTotalFollow(cachedTotal);
      } else {
        setGetLoadingFollow(true);
        await getFollowup(pageNoFollow)
          .then((res) => {
            const ungroupData = res.data.data.followUp.result;

            const groupedById = {};

            ungroupData.forEach((obj) => {
              if (!groupedById[obj.id]) {
                groupedById[obj.id] = [];
              }
              groupedById[obj.id].push(obj);
            });

            const newData = Object.values(groupedById);
            const newTotal = res.data.data.followUp.total;

            // Update the cache with new data
            setPageCacheFollow((prevCache) => ({
              ...prevCache,
              [pageNoFollow]: {
                cachedResponse: newData,
                cachedTotal: newTotal,
              },
            }));

            // Set state with new data
            setResponseFollow(newData);
            setTotalFollow(newTotal);
            setGetLoadingFollow(false);
          })
          .catch((err) => {
            toast.error(err.response?.data.error);
            setGetLoadingFollow(false);
          });
      }
    };

    fetchData();
  }, [pageNoFollow, pageCacheFollow]);

  useEffect(() => {
    const fetchGladeFollowups = async () => {
      if (gladeFollowupPageCache[pageNoFollow]) {
        const { cachedResponse, cachedTotal } =
          gladeFollowupPageCache[pageNoFollow];
        setGladeFollowupResponse(cachedResponse);
        setGladeFollowupTotal(cachedTotal);
        setGladeFollowupLoading(false);
        return;
      }

      setGladeFollowupLoading(true);
      try {
        const res = await getGladeFollowup(pageNoFollow);
        const groupedById = {};

        (res.data.result || []).forEach((item) => {
          const groupKey = `glade-${item.id}`;
          if (!groupedById[groupKey]) {
            groupedById[groupKey] = [];
          }
          groupedById[groupKey].push({
            ...item,
            isGlade: true,
            type: item.filerType,
            joint_firstname: item.joint_firstname || "",
            joint_lastname: item.joint_lastname || "",
          });
        });

        const newData = Object.values(groupedById);
        const newTotal =
          Number(res.data.total) ||
          Number(gladeFollowupPageCache[1]?.cachedTotal) ||
          0;

        setGladeFollowupPageCache((previousCache) => ({
          ...previousCache,
          [pageNoFollow]: {
            cachedResponse: newData,
            cachedTotal: newTotal,
          },
        }));
        setGladeFollowupResponse(newData);
        setGladeFollowupTotal(newTotal);
      } catch (err) {
        toast.error(
          err.response?.data?.error || "Failed to fetch Glade follow-ups"
        );
        setGladeFollowupResponse([]);
        setGladeFollowupTotal(0);
      } finally {
        setGladeFollowupLoading(false);
      }
    };

    fetchGladeFollowups();
  }, [pageNoFollow, gladeFollowupPageCache]);

  // useEffect(() => {
  //   const fetchIncompleteCerts = async () => {
  //     if (pageCacheIncompleteCerts[pageNoIncompleteCerts]) {
  //       // Data already in cache, no need for API call
  //       const { cachedResponse, cachedTotal } = pageCacheIncompleteCerts[pageNoIncompleteCerts];
  //       setIncompleteCertsData(cachedResponse);
  //       setTotalIncompleteCerts(cachedTotal);
  //     } else {
  //       setLoadingIncompleteCerts(true);
  //       await getIncompleteCertificates(pageNoIncompleteCerts)
  //         // await getAllCert(pageNoIncompleteCerts)

  //         .then((res) => {
  //           const ungroupedData = res.data.data.followUpWithOutInfo.result;

  //           const groupedById = {};
  //           ungroupedData.forEach((user) => {
  //             if (!groupedById[user.id]) {
  //               groupedById[user.id] = [];
  //             }
  //             else {
  //               user.type = 'Joint'
  //             }
  //             groupedById[user.id].push(user);
  //           });
  //           console.log("asdkfjaks", groupedById, res)

  //           const newData = Object.values(groupedById);
  //           const newTotal = res.data.data.followUpWithOutInfo.total;

  //           // Update the cache with new data
  //           setPageCacheIncompleteCerts((prevCache) => ({
  //             ...prevCache,
  //             [pageNoIncompleteCerts]: {
  //               cachedResponse: newData,
  //               cachedTotal: newTotal,
  //             },
  //           }));

  //           setIncompleteCertsData(newData);
  //           setTotalIncompleteCerts(newTotal);
  //           setLoadingIncompleteCerts(false);
  //         })
  //         .catch((err) => {
  //           toast.error(err.response?.data.error || "Failed to fetch report data");
  //           setLoadingIncompleteCerts(false);
  //         });
  //     }
  //   };

  //   fetchIncompleteCerts();
  // }, [pageNoIncompleteCerts, pageCacheIncompleteCerts]);


  useEffect(() => {
    const fetchData = async () => {
      if (pageCache[pageNo]) {
        // Data already in cache, no need for API call
        const { cachedResponse, cachedTotal } = pageCache[pageNo];
        setResponse(cachedResponse);
        setTotal(cachedTotal);
      } else {
        setGetLoading(true);
        await getAllCert(pageNo)
          .then((res) => {
            const newTotal = Number(res.data.data.certificate.total) ||
              Number(pageCache[1]?.cachedTotal) || 0;

            const ungroupData = res.data.data.certificate.result;

            const groupedById = {};

            ungroupData.forEach((obj) => {
              if (!groupedById[obj.id]) {
                groupedById[obj.id] = [];
              }
              groupedById[obj.id].push(obj);
            });

            const newData = Object.values(groupedById);
            console.log(newData);

            // Update the cache with new data
            setPageCache((prevCache) => ({
              ...prevCache,
              [pageNo]: { cachedResponse: newData, cachedTotal: newTotal },
            }));

            // Set state with new data
            setResponse(newData);
            setTotal(newTotal);
            setGetLoading(false);
          })
          .catch((err) => {
            toast.error(err.response?.data.error);
            setGetLoading(false);
          });
      }
    };

    fetchData();
  }, [pageNo, pageCache]);

  useEffect(() => {
    const fetchGladePendingCertificates = async () => {
      if (gladePageCache[pageNo]) {
        const { cachedResponse, cachedTotal } = gladePageCache[pageNo];
        setGladeResponse(cachedResponse);
        setGladeTotal(cachedTotal);
        setGladeLoading(false);
        return;
      }

      setGladeLoading(true);
      try {
        const res = await getGladePendingCertificates(pageNo);
        const groupedById = {};

        (res.data.result || []).forEach((item) => {
          const groupKey = `glade-${item.id}`;
          if (!groupedById[groupKey]) {
            groupedById[groupKey] = [];
          }
          groupedById[groupKey].push({
            ...item,
            isGlade: true,
            joint_firstname: item.joint_firstname || "",
            joint_lastname: item.joint_lastname || "",
            courseFirstType: item.filerType,
            courseSecondType: item.filerType,
          });
        });

        const newData = Object.values(groupedById);
        const newTotal = Number(res.data.total) ||
          Number(gladePageCache[1]?.cachedTotal) || 0;

        setGladePageCache((prevCache) => ({
          ...prevCache,
          [pageNo]: {
            cachedResponse: newData,
            cachedTotal: newTotal,
          },
        }));
        setGladeResponse(newData);
        setGladeTotal(newTotal);
      } catch (err) {
        toast.error(err.response?.data?.error || "Failed to fetch Glade pending certificates");
        setGladeResponse([]);
        setGladeTotal(0);
      } finally {
        setGladeLoading(false);
      }
    };

    fetchGladePendingCertificates();
  }, [pageNo, gladePageCache]);

  useEffect(() => {
    const fetchPhoneCourses = async () => {
      if (phoneCoursePageCache[phonePageNo]) {
        const { cachedResponse, cachedTotal } = phoneCoursePageCache[phonePageNo];
        setPhoneCourseResponse(cachedResponse);
        setPhoneCourseTotal(cachedTotal);
      } else {
        setPhoneCourseLoading(true);
        await getAllInProgressPhoneCourses(phonePageNo)
          .then((res) => {
            console.log("dsfasdvasv", res)
            const newTotal = res.data.total;
            // const ungroupData = res.data.data.certificate.result;

            // const groupedById = {};

            // ungroupData.forEach((obj) => {
            //   if (!groupedById[obj.id]) {
            //     groupedById[obj.id] = [];
            //   }
            //   groupedById[obj.id].push(obj);
            // });

            const newData = res.data.data;

            setPhoneCoursePageCache((prevCache) => ({
              ...prevCache,
              [phonePageNo]: {
                cachedResponse: newData,
                cachedTotal: newTotal,
              },
            }));

            setPhoneCourseResponse(newData);
            setPhoneCourseTotal(newTotal);
            setPhoneCourseLoading(false);
          })
          .catch((err) => {
            toast.error(err.response?.data?.error || "Failed to fetch phone courses");
            setPhoneCourseLoading(false);
          });
      }
    };

    fetchPhoneCourses();
  }, [phonePageNo, phoneCoursePageCache]);


  useEffect(() => {
    const fetchData = async () => {
      if (pageCacheFollowRetake[pageNoFollowRetake]) {
        // Data already in cache, no need for API call
        const { cachedResponse, cachedTotal } = pageCacheFollowRetake[pageNoFollowRetake];
        setResponseFollowRetake(cachedResponse);
        setTotalFollowRetake(cachedTotal);
      } else {
        setGetLoadingFollowRetake(true);
        await getFollowupRetake(pageNoFollowRetake)
          .then((res) => {
            const ungroupData = res.data.data.followUp.result;

            const groupedById = {};

            ungroupData.forEach((obj) => {
              if (!groupedById[obj.id]) {
                groupedById[obj.id] = [];
              }
              groupedById[obj.id].push(obj);
            });

            const newData = Object.values(groupedById);
            const newTotal = res.data.data.followUp.total;

            // Update the cache with new data
            setPageCacheFollow((prevCache) => ({
              ...prevCache,
              [pageNoFollowRetake]: {
                cachedResponse: newData,
                cachedTotal: newTotal,
              },
            }));

            // Set state with new data
            setResponseFollowRetake(newData);
            setTotalFollowRetake(newTotal);
            setGetLoadingFollowRetake(false);
          })
          .catch((err) => {
            toast.error(err.response?.data.error);
            setGetLoadingFollowRetake(false);
          });
      }
    };

    fetchData();
  }, [pageNoFollowRetake, pageCacheFollowRetake]);

  useEffect(() => {
    const fetchData = async () => {
      if (pageCacheRetake[pageNoRetake]) {
        // Data already in cache, no need for API call
        const { cachedResponse, cachedTotal } = pageCacheRetake[pageNoRetake];
        setResponseRetake(cachedResponse);
        setTotalRetake(cachedTotal);
      } else {
        setGetLoadingRetake(true);
        await getAllCertRetake(pageNoRetake)
          .then((res) => {
            const newTotal = res.data.data.certificate.total;

            const ungroupData = res.data.data.certificate.result;

            const groupedById = {};

            ungroupData.forEach((obj) => {
              if (!groupedById[obj.id]) {
                groupedById[obj.id] = [];
              }
              groupedById[obj.id].push(obj);
            });

            const newData = Object.values(groupedById);
            console.log(newData);

            // Update the cache with new data
            setPageCacheRetake((prevCache) => ({
              ...prevCache,
              [pageNoRetake]: { cachedResponse: newData, cachedTotal: newTotal },
            }));

            // Set state with new data
            setResponseRetake(newData);
            setTotalRetake(newTotal);
            setGetLoadingRetake(false);
          })
          .catch((err) => {
            toast.error(err.response?.data.error);
            setGetLoadingRetake(false);
          });
      }
    };

    fetchData();
  }, [pageNoRetake, pageCacheRetake]);

  const followUpGroups = [
    ...(responseFollow || []),
    ...(gladeFollowupResponse || []),
  ];
  const followUpsLoading = getloadingFollow || gladeFollowupLoading;
  const followUpsPageTotal = Math.max(
    Number(totalFollow) || 0,
    Number(gladeFollowupTotal) || 0
  );
  const followUpsDisplayTotal =
    (Number(totalFollow) || 0) + (Number(gladeFollowupTotal) || 0);

  const pendingCertificateGroups = [
    ...(response || []),
    ...(gladeResponse || []),
  ];
  const pendingCertificatesLoading = getloading || gladeLoading;
  const pendingCertificatesPageTotal = Math.max(
    Number(total) || 0,
    Number(gladeTotal) || 0
  );
  const pendingCertificatesDisplayTotal =
    (Number(total) || 0) + (Number(gladeTotal) || 0);

  return (
    <div>
      <div className="wrapper">
        <DashBoardSidebar />
        <div id="content" className="certificates-page">
          <DashboardNavbar />
          <section className="manage-students language_wrap">
            <h4 className="f26 ">Follow-ups</h4>
            <div className="card  mt-20">
              <div className="card-body">
                <div className="certificate-table-scroll" role="region" aria-label="Certificates table" tabIndex={0}>
                <table className="table certificate-table">
                  <colgroup><col className="certificate-name-col" /><col className="certificate-detail-col" /><col className="certificate-final-detail-col" /><col className="certificate-action-col" /></colgroup>
                  <thead>
                    <tr>
                      <th scope="col">Client Name</th>
                      <th scope="col">State</th>
                      <th scope="col">Follow-up Date</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {followUpsLoading ? (
                      <tr>
                        <td colSpan={4}>
                          <ThreeDots
                            height="40"
                            width="80"
                            radius="9"
                            color="#4fa94d"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                            wrapperClassName="spinner"
                            visible={true}
                          />
                        </td>
                      </tr>
                    ) : followUpGroups.length > 0 ? (
                      followUpGroups.map((users, ind) =>
                        users.map((follow, index) => (
                          <tr
                            key={`${follow.isGlade ? "glade" : "evergreen"}-${follow.id}-${follow.courseId || index}`}
                          >
                            <th
                              scope="row"
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              <div className="flex-i gAddBox__row">
                                {" "}
                                {follow.type === "Joint"
                                  ? follow.joint_firstname === "" &&
                                    follow.joint_lastname === ""
                                    ? follow.firstname +
                                    " " +
                                    follow.lastname +
                                    "'s Joint"
                                    : follow.joint_firstname +
                                    " " +
                                    follow.joint_lastname +
                                    " (Joint)"
                                  : follow.firstname + " " + follow.lastname}
                                {follow?.googleADs == true ? <span className="gAddBox flex-a">AD</span> : ""}
                                {follow.isGlade ? (
                                  <img
                                    className="glade-source-badge"
                                    src={gladeBadge}
                                    alt="Glade"
                                    title="Glade client"
                                  />
                                ) : ""}
                              </div>
                            </th>
                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {follow.state}
                            </td>
                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: follow.followup,
                              }}
                            ></td>
                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {follow.isGlade ? (
                                <Link
                                  className="text-black"
                                  to={`/followup?id=${follow.id}&courseId=${follow.courseId}&source=glade`}
                                >
                                  Edit
                                </Link>
                              ) : (
                                <Link
                                  className="text-black"
                                  to={`/followup?id=${follow.id}&courseId=${follow.courseId}`}
                                >
                                  Edit
                                </Link>
                              )}
                            </td>
                          </tr>
                        ))
                      )
                    ) : (
                      <tr>
                        <td colSpan={4}>No followup found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                </div>

                {!followUpsLoading && followUpsPageTotal > 10 && (
                  <PaginatedItems responsive
                    pageSize={10}
                    total={followUpsPageTotal}
                    displayTotal={followUpsDisplayTotal}
                    pageNo={pageNoFollow}
                    setPageNo={setPageNoFollow}
                  />
                )}
              </div>
            </div>
          </section>
          {/* <section className="manage-students language_wrap mt-4">
            <h4 className="f26">Incomplete Certificates</h4>
            <div className="card mt-20">
              <div className="card-body" style={{ overflowX: "auto" }}>

                <table className="table table-responsive">
                  <thead>
                    <tr>
                      <th scope="col">User Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">CC Enrolled Date</th>
                      <th scope="col">DE Enrolled Date</th>
                      <th scope="col">Course Name</th>


                     
                      <th scope="col">Action</th>
                    </tr>
                  </thead>

                  <tbody >
                    {loadingIncompleteCerts ? (
                      <tr>
                        <td colSpan={6}>
                          <ThreeDots
                            height="40"
                            width="80"
                            radius="9"
                            color="#4fa94d"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                            wrapperClassName="spinner"
                            visible={true}
                          />
                        </td>
                      </tr>
                    ) : incompleteCertsData && incompleteCertsData.length > 0 ? (
                     
                      incompleteCertsData.map((users, ind) =>
                        users.map((follow, index) => (
                          <tr key={index}>

                            <th
                              scope="row"
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              <div className="flex-i gAddBox__row">
                                {" "}
                                {follow.type === "Joint"
                                  ? follow.joint_firstname === "" &&
                                    follow.joint_lastname === ""
                                    ? follow.firstname +
                                    " " +
                                    follow.lastname +
                                    "'s Joint"
                                    : follow.joint_firstname +
                                    " " +
                                    follow.joint_lastname +
                                    " (Joint)"
                                  : follow.firstname + " " + follow.lastname}
                                {follow?.googleADs == true ? <span className="gAddBox flex-a">AD</span> : ""}
                              </div>
                            </th>
                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {follow.email}
                            </td>

                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >

                              {follow.Enrolled_in_CC && moment(follow.Enrolled_in_CC).format("MMMM Do YYYY")}

                            </td>

                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {follow.Enrolled_in_DE && moment(follow.Enrolled_in_DE).format("MMMM Do YYYY")}

                            </td>

                            <td
                              style={{
                                borderBottomWidth: index !== users.length - 1 ? "0px" : "",
                                fontWeight: 'bold',
                                color: '#333',
                                padding: '5px',
                              }}
                            >
                              {(follow.CC.toLowerCase() === "checked" && follow.judicialdistrict_state_first == "") && (
                                <>
                                  <span style={{ fontSize: '14px' }}>CC</span>
                                  <span style={{ fontSize: '14px' }}>{follow.DE.toLowerCase() === "checked" && follow.judicialdistrict_state_second == "" && " & "}</span>
                                </>

                              )}

                              {(follow.DE.toLowerCase() === "checked" && follow.judicialdistrict_state_second == "") && (
                                <>
                                  <span style={{ fontSize: '14px' }}>DE</span>


                                </>
                              )}
                            </td>

                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              <Link
                                className="text-black"
                                to={`/editstudent?id=${follow.id}`}
                              >
                                View Profile
                              </Link>
                            </td>
                          </tr>
                        ))
                      )
                    ) : (
                      <tr>
                        <td colSpan={6}>No incomplete certificates found</td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {!loadingIncompleteCerts && totalIncompleteCerts > 10 && (
                  <PaginatedItems
                    total={totalIncompleteCerts}
                    pageNo={pageNoIncompleteCerts}
                    setPageNo={setPageNoIncompleteCerts}
                  />
                )}
              </div>
            </div>
          </section> */}
          <section className="manage-students language_wrap mt-5">
            {/* <h4 className="f26 ">DE Certificates</h4> */}
            <h4 className="f26 ">Pending Certificates</h4>
            <div className="card  mt-20">
              <div className="card-body">
                <div className="certificate-table-scroll" role="region" aria-label="Certificates table" tabIndex={0}>
                <table className="table certificate-table">
                  <colgroup><col className="certificate-name-col" /><col className="certificate-detail-col" /><col className="certificate-final-detail-col" /><col className="certificate-action-col" /></colgroup>
                  <thead>
                    <tr>
                      <th scope="col">Client Name</th>
                      <th scope="col">Course 1</th>
                      <th scope="col">Course 2</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {pendingCertificatesLoading ? (
                      <tr>
                        <td colSpan={4}>
                          <ThreeDots
                            height="40"
                            width="80"
                            radius="9"
                            color="#4fa94d"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                            wrapperClassName="spinner"
                            visible={true}
                          />
                        </td>
                      </tr>
                    ) : pendingCertificateGroups.length > 0 ? (
                      pendingCertificateGroups.map((users, ind) =>
                        users.map((cert, index) => (
                          <tr key={`${cert.isGlade ? "glade" : "evergreen"}-${cert.id}-${cert.filerType || index}`}>
                            <th
                              scope="row"
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              <div className="flex-i gAddBox__row">
                                {cert.courseFirstType === "Joint" ||
                                  cert.courseSecondType === "Joint"
                                  ? cert.joint_firstname === "" &&
                                    cert.joint_lastname === ""
                                    ? cert.firstname +
                                    " " +
                                    cert.lastname +
                                    "'s Joint"
                                    : cert.joint_firstname +
                                    " " +
                                    cert.joint_lastname +
                                    " (Joint)"
                                  : cert.firstname + " " + cert.lastname}
                                {cert?.googleADs == true ? <span className="gAddBox flex-a">AD</span> : ""}
                                {cert.isGlade ? (
                                  <img
                                    className="glade-source-badge"
                                    src={gladeBadge}
                                    alt="Glade"
                                    title="Glade client"
                                  />
                                ) : ""}
                              </div>
                            </th>
                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {cert.isGlade ? (
                                Number(cert.courseFirstPending) === 1 ? "Pending" : ""
                              ) : cert.courseFirstAud14 ||
                                cert.courseFirstCompleted !== "" ? (
                                cert.courseFirstGenerated !== "" ? (
                                  cert.courseFirstDownloaded &&
                                    cert.courseFirstDownloaded !== "yes" ? (
                                    <a
                                      target="_blank"
                                      href={cert.courseFirstDownloaded}
                                      className="text-black"
                                    >
                                      {cert.courseFirstDate
                                        ? cert.courseFirstDate.split("T")[0]
                                        : ""}
                                    </a>
                                  ) : cert.courseFirstDate ? (
                                    <span className="tooltips">
                                      {cert.courseFirstDate.split("T")[0]}
                                    </span>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  "Pending"
                                )
                              ) : cert.courseFirstDate &&
                                cert.courseFirstGenerated === "" ? (
                                ""
                              ) : (
                                ""
                              )}
                            </td>
                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {" "}
                              {cert.isGlade ? (
                                Number(cert.courseSecondPending) === 1 ? "Pending" : ""
                              ) : cert.courseSecondAud49 !== "" ||
                                cert.courseSecondCompleted !== "" ? (
                                cert.courseSecondGenerated !== "" ? (
                                  cert.downloaded &&
                                    cert.downloaded !== "yes" ? (
                                    <a
                                      target="_blank"
                                      href={cert.downloaded}
                                      className="text-black"
                                    >
                                      {cert.courseSecondDate
                                        ? cert.courseSecondDate.split("T")[0]
                                        : ""}
                                    </a>
                                  ) : cert.courseSecondDate ? (
                                    <span className="tooltips">
                                      {cert.courseSecondDate.split("T")[0]}
                                    </span>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  "Pending"
                                )
                              ) : cert.courseSecondDate &&
                                cert.courseSecondGenerated === "" ? (
                                ""
                              ) : (
                                ""
                              )}
                            </td>
                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              <Link
                                className="text-black"
                                to={cert.isGlade
                                  ? `/glade-client-details?id=${cert.id}`
                                  : `/editstudent?id=${cert.id}&from=cert`}
                              >
                                Edit
                              </Link>
                            </td>
                          </tr>
                        ))
                      )
                    ) : (
                      <tr>
                        <td colSpan={4}>No certificates found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                </div>

                {!pendingCertificatesLoading && pendingCertificatesPageTotal > 10 && (
                  <PaginatedItems responsive
                    pageSize={10}
                    total={pendingCertificatesPageTotal}
                    displayTotal={pendingCertificatesDisplayTotal}
                    pageNo={pageNo}
                    setPageNo={setPageNo}
                  />
                )}
              </div>
            </div>
          </section>

          <section className="manage-students language_wrap mt-5 certificate-phone-section">
            <h4 className="f26 ">In progress Phone courses</h4>
            <div className="card  mt-20">
              <div className="card-body">
                <div className="certificate-table-scroll" role="region" aria-label="Certificates table" tabIndex={0}>
                <table className="table certificate-table">
                  <colgroup><col className="certificate-name-col" /><col className="certificate-detail-col" /><col className="certificate-final-detail-col" /><col className="certificate-action-col" /></colgroup>
                  <thead>
                    <tr>
                      <th scope="col">Client Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Courses</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {phoneCourseLoading ? (
                      <tr>
                        <td colSpan={4}>
                          <ThreeDots
                            height="40"
                            width="80"
                            radius="9"
                            color="#4fa94d"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                            wrapperClassName="spinner"
                            visible={true}
                          />
                        </td>
                      </tr>
                    ) : phoneCourseResponse && phoneCourseResponse.length > 0 ? (
                      phoneCourseResponse.map((cert, index) =>
                        <tr key={index}>
                          <th
                            scope="row"
                          // style={{
                          //   borderBottomWidth:
                          //     index !== users.length - 1 ? "0px" : "",
                          // }}
                          >
                            <div className="flex-i gAddBox__row">

                              {cert.firstname + " " + cert.lastname}
                            </div>
                          </th>
                          <td
                          // style={{
                          //   borderBottomWidth:
                          //     index !== users.length - 1 ? "0px" : "",
                          // }}
                          style={{
                           textTransform:'none'
                          }}
                          >
                            {cert.email}
                          </td>
                          <td
                          // style={{
                          //   borderBottomWidth:
                          //     index !== users.length - 1 ? "0px" : "",
                          // }}
                          >
                            {cert.course}

                          </td>
                          <td
                          // style={{
                          //   borderBottomWidth:
                          //     index !== users.length - 1 ? "0px" : "",
                          // }}
                          >
                            <Link
                              className="text-black"
                              to={`/editstudent?id=${cert.userId}`}
                            >
                              Edit
                            </Link>
                          </td>
                        </tr>
                      )
                    ) : (
                      <tr>
                        <td colSpan={4}>No certificates found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                </div>

                {!phoneCourseLoading && phoneCourseTotal !== 0 && phoneCourseTotal > 10 && (
                  <PaginatedItems responsive
                  pageSize={10}
                    total={phoneCourseTotal}
                    pageNo={phonePageNo}
                    setPageNo={setPhonePageNo}
                  />
                )}
              </div>
            </div>
          </section>

          <section className="manage-students language_wrap mt-5">
            <h4 className="f26 ">Re-Take Follow-ups</h4>
            <div className="card  mt-20">
              <div className="card-body">
                <div className="certificate-table-scroll" role="region" aria-label="Certificates table" tabIndex={0}>
                <table className="table certificate-table">
                  <colgroup><col className="certificate-name-col" /><col className="certificate-detail-col" /><col className="certificate-final-detail-col" /><col className="certificate-action-col" /></colgroup>
                  <thead>
                    <tr>
                      <th scope="col">Client Name</th>
                      <th scope="col">State</th>
                      <th scope="col">Follow-up Date</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {getloadingFollowRetake ? (
                      <tr>
                        <td colSpan={4}>
                          <ThreeDots
                            height="40"
                            width="80"
                            radius="9"
                            color="#4fa94d"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                            wrapperClassName="spinner"
                            visible={true}
                          />
                        </td>
                      </tr>
                    ) : responseFollowRetake && responseFollowRetake.length > 0 ? (
                      responseFollowRetake.map((users, ind) =>
                        users.map((follow, index) => (
                          <tr key={index}>
                            <th
                              scope="row"
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              <div className="flex-i gAddBox__row">
                                {" "}
                                {follow.type === "Joint"
                                  ? follow.joint_firstname === "" &&
                                    follow.joint_lastname === ""
                                    ? follow.firstname +
                                    " " +
                                    follow.lastname +
                                    "'s Joint"
                                    : follow.joint_firstname +
                                    " " +
                                    follow.joint_lastname +
                                    " (Joint)"
                                  : follow.firstname + " " + follow.lastname}
                                {follow?.googleADs == true ? <span className="gAddBox flex-a">AD</span> : ""}
                              </div>
                            </th>
                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {follow.state}
                            </td>
                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: follow.followup,
                              }}
                            ></td>
                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              <Link
                                className="text-black"
                                to={`/followup?id=${follow.id}&courseId=${follow.courseId}&retake=true`}
                              >
                                Edit
                              </Link>
                            </td>
                          </tr>
                        ))
                      )
                    ) : (
                      <tr>
                        <td colSpan={4}>No followup found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                </div>

                {!getloadingFollowRetake && totalFollowRetake !== 0 && totalFollowRetake > 10 && (
                  <PaginatedItems responsive
                  pageSize={10}
                    total={totalFollowRetake}
                    pageNo={pageNoFollowRetake}
                    setPageNo={setPageNoFollowRetake}
                  />
                )}
              </div>
            </div>
          </section>
          <section className="manage-students language_wrap mt-5">
            <h4 className="f26 ">Re-Take Pending Certificates</h4>

            <div className="card  mt-20">
              <div className="card-body">
                <div className="certificate-table-scroll" role="region" aria-label="Certificates table" tabIndex={0}>
                <table className="table certificate-table">
                  <colgroup><col className="certificate-name-col" /><col className="certificate-detail-col" /><col className="certificate-final-detail-col" /><col className="certificate-action-col" /></colgroup>
                  <thead>
                    <tr>
                      <th scope="col">Client Name</th>
                      <th scope="col">Course 1</th>
                      <th scope="col">Course 2</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {getloadingRetake ? (
                      <tr>
                        <td colSpan={4}>
                          <ThreeDots
                            height="40"
                            width="80"
                            radius="9"
                            color="#4fa94d"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                            wrapperClassName="spinner"
                            visible={true}
                          />
                        </td>
                      </tr>
                    ) : responseRetake && responseRetake.length > 0 ? (
                      responseRetake.map((users, ind) =>
                        users.map((cert, index) => (
                          <tr key={index}>
                            <th
                              scope="row"
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              <div className="flex-i gAddBox__row">
                                {cert.courseFirstType === "Joint" ||
                                  cert.courseSecondType === "Joint"
                                  ? cert.joint_firstname === "" &&
                                    cert.joint_lastname === ""
                                    ? cert.firstname +
                                    " " +
                                    cert.lastname +
                                    "'s Joint"
                                    : cert.joint_firstname +
                                    " " +
                                    cert.joint_lastname +
                                    " (Joint)"
                                  : cert.firstname + " " + cert.lastname}
                                {cert?.googleADs == true ? <span className="gAddBox flex-a">AD</span> : ""}
                              </div>
                            </th>
                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {cert.courseFirstAud14 ||
                                cert.courseFirstCompleted !== "" ? (
                                cert.courseFirstGenerated !== "" ? (
                                  cert.courseFirstDownloaded &&
                                    cert.courseFirstDownloaded !== "yes" ? (
                                    <a
                                      target="_blank"
                                      href={cert.courseFirstDownloaded}
                                      className="text-black"
                                    >
                                      {cert.courseFirstDate
                                        ? cert.courseFirstDate.split("T")[0]
                                        : ""}
                                    </a>
                                  ) : cert.courseFirstDate ? (
                                    <span className="tooltips">
                                      {cert.courseFirstDate.split("T")[0]}
                                    </span>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  "Pending"
                                )
                              ) : cert.courseFirstDate &&
                                cert.courseFirstGenerated === "" ? (
                                ""
                              ) : (
                                ""
                              )}
                            </td>
                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {" "}
                              {cert.courseSecondAud49 !== "" ||
                                cert.courseSecondCompleted !== "" ? (
                                cert.courseSecondGenerated !== "" ? (
                                  cert.downloaded &&
                                    cert.downloaded !== "yes" ? (
                                    <a
                                      target="_blank"
                                      href={cert.downloaded}
                                      className="text-black"
                                    >
                                      {cert.courseSecondDate
                                        ? cert.courseSecondDate.split("T")[0]
                                        : ""}
                                    </a>
                                  ) : cert.courseSecondDate ? (
                                    <span className="tooltips">
                                      {cert.courseSecondDate.split("T")[0]}
                                    </span>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  "Pending"
                                )
                              ) : cert.courseSecondDate &&
                                cert.courseSecondGenerated === "" ? (
                                ""
                              ) : (
                                ""
                              )}
                            </td>
                            <td
                              style={{
                                borderBottomWidth:
                                  index !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              <Link
                                className="text-black"
                                to={`/editstudent?id=${cert.id}&from=cert`}
                              >
                                Edit
                              </Link>
                            </td>
                          </tr>
                        ))
                      )
                    ) : (
                      <tr>
                        <td colSpan={4}>No certificates found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                </div>

                {!getloadingRetake && totalRetake !== 0 && totalRetake > 10 && (
                  <PaginatedItems responsive
                  pageSize={10}
                    total={totalRetake}
                    pageNo={pageNoRetake}
                    setPageNo={setPageNoRetake}
                  />
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Certificates;
